var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPresentation(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 33,
    viewBox: "0 0 33 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.4691 23.69V26.3983",
    stroke: "#4C5B66",
    strokeWidth: 1.32728,
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M27.8441 8.52328V22.6066C27.8433 22.8937 27.7288 23.1687 27.5259 23.3717C27.3229 23.5747 27.0478 23.6891 26.7608 23.69H6.17745C5.8904 23.6891 5.61534 23.5747 5.41236 23.3717C5.20939 23.1687 5.09497 22.8937 5.09412 22.6066V6.89828H27.8441V8.52328Z",
    fill: "url(#paint0_linear_570_189957)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M17.5524 26.3983H15.3857V29.6483H17.5524V26.3983Z",
    fill: "#5EA7FE"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M28.9274 4.73164V6.89831H27.8441H5.09408H4.01074V4.73164H28.9274Z",
    fill: "#5EA7FE"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M5.09408 6.89831H4.01074V4.73164H28.9274V6.89831H27.8441H5.09408Z",
    fill: "#8BC5FC",
    stroke: "#4C5B66",
    strokeWidth: 1.32728,
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M5.09412 8.52328V22.6066C5.09497 22.8937 5.20939 23.1687 5.41236 23.3717C5.61534 23.5747 5.8904 23.6891 6.17745 23.69H26.7608C27.0478 23.6891 27.3229 23.5747 27.5259 23.3717C27.7288 23.1687 27.8433 22.8937 27.8441 22.6066V8.52328",
    stroke: "#4C5B66",
    strokeWidth: 1.32728,
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M17.5524 26.3983H15.3857V29.6483H17.5524V26.3983Z",
    stroke: "#4C5B66",
    strokeWidth: 1.32728,
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M10.5108 9.60661H8.34412V11.7733H10.5108V9.60661Z",
    fill: "#DDB346",
    stroke: "#815719",
    strokeOpacity: 0.5,
    strokeWidth: 0.663638,
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M10.5108 13.9399H8.34412V16.1066H10.5108V13.9399Z",
    fill: "#DDB346",
    stroke: "#815719",
    strokeOpacity: 0.5,
    strokeWidth: 0.663638,
    strokeLinejoin: "round"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M10.5108 18.1899H8.34412V20.3566H10.5108V18.1899Z",
    fill: "#DDB346",
    stroke: "#815719",
    strokeOpacity: 0.5,
    strokeWidth: 0.663638,
    strokeLinejoin: "round"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M12.6774 9.60661H18.0941",
    stroke: "#4C5B66",
    strokeWidth: 0.663638,
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M12.6774 11.7733H22.9691",
    stroke: "#4C5B66",
    strokeWidth: 0.663638,
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M12.6774 13.94H18.0941",
    stroke: "#4C5B66",
    strokeWidth: 0.663638,
    strokeLinejoin: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M12.6774 16.1066H22.9691",
    stroke: "#4C5B66",
    strokeWidth: 0.663638,
    strokeLinejoin: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M12.6774 18.2733H18.0941",
    stroke: "#4C5B66",
    strokeWidth: 0.663638,
    strokeLinejoin: "round"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M12.6774 20.44H22.9691",
    stroke: "#4C5B66",
    strokeWidth: 0.663638,
    strokeLinejoin: "round"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M24.0524 11.7733H25.1358",
    stroke: "#4C5B66",
    strokeWidth: 0.663638,
    strokeLinejoin: "round"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M24.0524 16.1066H25.1358",
    stroke: "#4C5B66",
    strokeWidth: 0.663638,
    strokeLinejoin: "round"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M24.0524 20.44H25.1358",
    stroke: "#4C5B66",
    strokeWidth: 0.663638,
    strokeLinejoin: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_570_189957",
    x1: 17.3441,
    y1: 16.3983,
    x2: 18.0108,
    y2: 15.3983,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF9DC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPresentation);
export default __webpack_public_path__ + "static/media/presentation.3de7426eb7226a5eb2195297379dacf4.svg";
export { ForwardRef as ReactComponent };